import questionError from './src'
questionError.install = (Vue) => {
  Vue.component(questionError.name, questionError)
}
export default questionError



// WEBPACK FOOTER //
// ./packages/question-error/index.js